import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Excel = () => (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, { children: [_jsx("text", Object.assign({ transform: "translate(2.24 11.8)", style: {
                fontFamily: 'AktivGroteskGeberit-Bold,Aktiv Grotesk Geberit',
                fontWeight: 700,
            } }, { children: "X" })), _jsx("path", { d: "M0 5v9h4v2h12V4l-4-4H4v5Zm12-3.59L14.59 4H12ZM8 6v7H1V6ZM5 5V1h6v4h4v10H5v-1h4V5Z" })] })));
Excel.iconName = 'Excel Icon';
export default Excel;
